/*
This translate function wraps the i18next TFunction (i18next.t) in order of having a better control over all translation function calls.
This setup let us calling the labrary funcition with pure JavaScript avoiding calling a hook for each component.
Plus we can add more feature like filter potencial breaks or add custom TypeScript types.
*/
// import { TOptions, StringMap } from 'i18next'
import i18n from './init'

/*
const translate = (key: string | StringMap, options?: TOptions): string => {
  const output: string = i18n.t(key, options)
  if (output === key) return ''
  return output
}
*/

export default i18n.t
